import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useMediaQueries, useQueryParams} from 'presentation/pages';

import {translations} from 'presentation/translations-new';
import {HandleSelectCardParams} from '../../../ExamUnitsSelfNetwork/hooks/useExamUnitsSelfNetwork/types';
import {UseExamAdvanceUnits} from './types';

const {selfNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function useExamAdvanceUnits({advanceUnits, handleNextStep}: UseExamAdvanceUnits) {
	const {isMobile} = useMediaQueries();
	const {
		SEARCH_PARAMS: {query},
		clearSearch,
	} = useQueryParams();
	const setBookingData = useBookingStore(state => state.setBookingData);
	const {specialtyName} = useBookingStore(state => state.bookingData);
	const title = advanceUnits.length > 1 ? selfNetwork.advanceUnits : selfNetwork.advanceUnit;

	const handleSelectCard = (params: HandleSelectCardParams) => {
		setBookingData(prev => ({
			...prev,
			unitCode: params.code,
			unitName: params.name,
			unitAddress: params.address,
			bookingRedirect: false,
		}));

		clearSearch();
		handleNextStep();
	};

	return {
		isMobile,
		query,
		specialtyName,
		title,
		handleSelectCard,
	};
}
